import config from '../config';

config.env = 'production';
export default config;
